// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes loading-bar-slide{0%{opacity:1;transform:translateX(-120%)}85%{opacity:1;transform:translateX(100%)}to{opacity:0;transform:translateX(120%)}}.loading-bar{animation:loading-bar-slide 1.5s linear infinite;background:linear-gradient(270deg,currentColor,currentColor 65%,transparent);color:var(--primary);transform-origin:left center;width:70%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
